import React, { useState, useEffect } from 'react'
import api from '../components/api'
import axios from 'axios'

const Modal = (props) => {

    //var linkAPI = 'http://172.16.1.253:3600'
    var linkAPI = 'https://cdn.hospitaissaudaveis.org/'

    var destaque_id = props.destaque_id

    var [ordem, setOrdem] = useState()
    var [titulo, setTitulo] = useState('')
    var [descricao, setDescricao] = useState('')
    var [imagem, setImagem] = useState('')
    var [link, setLink] = useState('')
    var [nt_codigo, setNt_codigo] = useState()
    var [pagina, setPagina_id] = useState()
    var [file, setFile] = useState('')

    var [tipoLink, setTipoLink] = useState('')
    
    var [na_codigo, setNa_codigo] = useState()
    
    

    function salvar() {


        if (tipoLink == '') {

            //window.toastr.error('Por favor, informe o <b>Tipo de link</b>')
            //return false

        }

        if (titulo == '') {

            window.toastr.error('Por favor, informe o <b>T&iacute;tiulo</b>')
            return false

        }


        if (link == '') {

            window.toastr.error('Por favor, informe o <b>Link</b>')
            return false

        }


        

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {



                    const formData = new FormData();
                    const imagefile = document.querySelector("#file1");

                    //console.log(imagefile.files[0])

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagem", imagefile.files[0]);
                    formData.append("nt_codigo", nt_codigo); // string junto ao formData.
                    formData.append("link", link)
                    formData.append("tipoLink", tipoLink)
                    formData.append("titulo", titulo)
                    formData.append("descricao", descricao)
                    formData.append("ordem", ordem)
                    formData.append("pagina_id", pagina)

                    //console.log(formData)
                    //  return false


                    if (!isNaN(destaque_id)) {

                        //console.log('altera')
                        //return false

                        axios.put(`${linkAPI}destaque/${destaque_id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalDestaque").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaDestaques()



                        }).catch((err) => {

                            console.log(err.response)

                        })



                    } else {

                        //console.log('inclui')
                        //return false

                        axios.post(linkAPI + 'destaque/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': '!nf0$@ud#2',
                        }
                        }).then(response => {

                            //console.log(response)

                            window.$("#modalDestaque").modal('hide');
                            
        
                            window.toastr.success('Salvo com sucesso!')

                            props.listaDestaques()



                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }

                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        

    }

    function apagar() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                    api.delete(`destaque/${destaque_id}`).then((result) => {

                        console.log(result.data)
                        window.$("#modalDestaque").modal('hide');
                        window.toastr.success('Apagado com sucesso!')
                        props.listaDestaques()

                    }).catch((err) => {

                        console.log(err)

                    })

                        
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }

    function limpaCampos() {


        setNt_codigo()
        setLink('')
        setTitulo('')
        setDescricao('')
        setOrdem()
        setPagina_id()
        setFile('')
        document.getElementById('file1').value = ''


    }

    async function carregaDados() {

        

        if (destaque_id) {

            await api.get(`destaqueListaUm/${destaque_id}`).then((result) => {

                console.log(result.data)

                var data = result.data[0]

                if (data) {

                    setOrdem(data.ordem)
                    setTitulo(data.titulo)
                    setDescricao(data.descricao)
                    setImagem(data.imagem)
                    setLink(data.link)

                }

                
            }).catch((err) => {

                console.log(err.response)

            })

        }
        
    }


    useEffect(() => {

        limpaCampos()
        carregaDados()

    }, [destaque_id])

    return (

        <div>


                <div className="modal fade" id="modalDestaque" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Destaque</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Ordem</label>
                                                <select className="form-control" value={ordem} onChange={event => setOrdem(event.target.value)} >

                                                    <option value={1}>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>

                                                </select>
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label>Título</label>
                                                <input type="text" className="form-control" placeholder="" value={titulo} onChange={event => setTitulo(event.target.value)} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Descrição</label>
                                                <textarea  className="form-control" rows="3" placeholder="" value={descricao} onChange={event => setDescricao(event.target.value)} maxlength="500" />
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-12" style={{ display: 'none'}}>
                                            <div class="form-group">
                                                <label>Tipo Link</label>
                                                <select  className="form-control" value={tipoLink} onChange={event => setTipoLink(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="I">Interno</option>
                                                    <option value="E">Externo</option>
                                                </select>
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-12" >
                                            <div class="form-group">
                                                <label>Link</label>
                                                <input type="text" className="form-control" value={link} onChange={event => setLink(event.target.value)} />
                                                  
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Imagem</label>
                                                <input type="text" className="form-control" placeholder="" value={imagem} readOnly style={{cursor: 'pointer' }} onClick={() => window.open(`${linkAPI}uploads/destaque/${imagem}`)}/>
                                                
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Upload nova imagem</label>
                                                <input type="file" className="form-control" id="file1" value={file} onChange={event => setFile(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                      


                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-danger" onClick={() => apagar()} style={{ display: 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )

}


export default Modal